import CardTable from "components/CardTable/CardTable";
import React, { useEffect } from "react";
import { columns } from "./columns";
import AssignmentIcon from "@mui/icons-material/Assignment";
import { RequestForm } from "./RequestForm";
import { FilterSwitches } from "./FilterSwitches";
import { useSelector } from "react-redux";
import { useSearch } from "hooks/useSearch";
import { ordersSelector } from "./selectors";
import Snackbar from "components/Snackbar/Snackbar";
import { useValidateReload } from "hooks/useValidateReload";

const tableKey = "orders";

export const OrdersView = () => {
  const orders = useSelector(ordersSelector);
  const { isOpen, color, message, isLoadingComp, configTables } = useSelector(
    ({ search }) => search
  );
  const { clearSnackbar, buildTableConfig, handlePage } = useSearch();
  const { page = 0, pageSize = 10 } = configTables[tableKey] || {};

  useEffect(() => {
    !configTables[tableKey] && buildTableConfig(tableKey);
  }, []);

  // Si al filtrar o recargar quedan menos pedidos, se regresa a la primera página
  // para que la tabla no se quede en una página que ya no existe
  useEffect(() => {
    if (page > 0 && page * pageSize >= orders.length) handlePage(0, tableKey);
  }, [orders.length, page, pageSize]);

  useValidateReload([
    "loadingOrders",
    "loadingCoupons",
    "loadingApplyCoupon",
    "loadingAddComment",
  ], null, []);

  
  return (
    <>
      <CardTable
        columns={columns}
        data={orders}
        hasControl
        hasHeader
        icon={<AssignmentIcon />}
        title="Seguimiento de pedidos"
        titleBlock
        blockBtn
        tableKey={tableKey}
        rowStyle={false}
        isLoading={isLoadingComp?.loadingOrders}
        tableContent={
          <>
            <RequestForm />
            <FilterSwitches />
          </>
        }
      />
      <Snackbar
        place="tr"
        color={color}
        message={message}
        open={isOpen}
        closeNotification={clearSnackbar}
        close
      />
    </>
  );
};
